<template>
  <div>
    <el-table
      :data="labels.data"
      highlight-current-row
      :row-class-name="tableRowClassName"
      @row-click="openCampaignTable"
    >
      <el-table-column label="Name" prop="name"></el-table-column>
      <el-table-column label="Balance" prop="balance">
        <template slot-scope="props">
          {{ props.row.balance ? '$'+props.row.balance.toFixed(2) : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="Created at">
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Updated at">
        <template slot-scope="props">
          {{ props.row.updated_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right">
        <template slot-scope="props">
          <el-tooltip content="Deposit" placement="top">
            <el-button
              type="warning"
              circle
              size="small"
              icon="el-icon-money"
              @click="openDeposit(props.row)"
            ></el-button>
          </el-tooltip>
          <!-- <el-tooltip content="Preview campaigns" placement="top">
            <el-button
              type="primary"
              circle
              size="small"
              icon="el-icon-document"
              @click="openCampaignTable(props.row.vc_campaign)"
            ></el-button>
          </el-tooltip> -->
          <el-tooltip content="Create campaign" placement="top">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-plus"
              @click="openCampaignForm(props.row)"
            ></el-button>
          </el-tooltip>
          <!-- <el-tooltip content="Edit label" placement="top">
            <el-button
              type="warning"
              circle
              size="small"
              icon="el-icon-edit"
              @click="openEditLabel(props.row)"
            ></el-button>
          </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="labels.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, pager"
      :total="labels.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('vcLabel', ['labels', 'page', 'page_size']),
    ...mapState('vcTrack', ['active_label']),
  },

  methods: {
    ...mapActions('vcLabel', ['readLabels', 'depositLabel']),
    ...mapMutations('vcLabel', [
      'setLabel',
      'setLabelDeposit',
      'setPage',
      'setPageSize'
    ]),
    ...mapMutations('vcTrack', ['setTracks', 'setActiveLabel', 'setTrackForm']),

    openDeposit(row) {
      this.setLabelDeposit(true)
      this.setLabel(row)
    },
    openCampaignTable(row) {
      this.setActiveLabel(row.id)
      this.setTracks(row.vc_campaign_track)
    },
    openCampaignForm(row) {
      this.setActiveLabel(row.id)
      this.setTrackForm(true)
    },
    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readLabels()
    },
    currentChange(page) {
      this.setPage(page)
      this.setTracks([])
      this.readLabels()
    },
    tableRowClassName({ row }) {
      if (row.id === this.active_label) {
        return 'active-row'
      }
      return 'pointer'
    }
  },

  created() {
    this.readLabels()
  }
}
</script>

<style>
.el-table .active-row {
  cursor: pointer;
  background: #fce9ee !important;
}
</style>
